import { BooleanField, Button, Datagrid, ExportButton, FunctionField, List, ReferenceField, ShowButton, TextField, TopToolbar, useListContext } from "react-admin";
import { useAppSelector } from "../../store/hooks";
import ResourceSelectDialogButton from "../Common/ResourceSelectDialogButton";
import { useEffect, useState } from "react";
import CityService from "../../services/CityService";
import CityResponse from "../../interfaces/City/CityResponse";
import {useNavigate} from "react-router-dom";
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import FilterListOffIcon from "@mui/icons-material/FilterListOff";
import { formatDateTimeWithSeconds } from "../../utils/DateTimeUtils";
import CommonFilterCard, { CommonFilterField } from "../Common/CommonFilterCard";
import StyledDatagridWrapper, { commonDatagridSx } from "../Common/StyledDatagridWrapper";


interface AreaListProps{
  isMultiSelect?: boolean;
}
const cityService =new CityService();
const ListActions = (props: any) => {
    const { setFilters } = useListContext();
    const resetFilter = () => {
      setFilters({}, [], false);
    };
    const navigate = useNavigate();

    return (
      <TopToolbar>
        <Button
          variant="text"
          size={"small"}
          onClick={resetFilter}
          startIcon={<FilterListOffIcon />}
          label="Clear filters"
        />
        <Button
          variant="text"
          size={"small"}
          onClick={()=>{
            navigate("/Areas/create")
          }}
          startIcon={<ControlPointIcon />}
          label="Create"
        />
        <ExportButton/>
      </TopToolbar>
    );
};
const AreaList = (props:AreaListProps) => {
    const [cities, setCities] = useState<CityResponse[]>([]);
    const isCustomSelectOpen = useAppSelector((state) => state.customSelect.value.open);
    const checkMultiSelect = () => {
      return props.isMultiSelect?<></>:false
    }
    const filterFields: CommonFilterField[] = [
        { type: "text", label: "Search by area Name", source: "name" },
        { type: "text", label: "Search by city id", source: "cityId" },
        {
          type: "select",
          label: "City",
          source: "cityId",
          options: cities.map((eachCity: any) => ({
            value: eachCity?.id,
            label: eachCity?.name,
          })),
        },
    ]

    useEffect(() => {
        cityService.fetchAllCities(100, 0, {isCurrentlyServing:"YES"}, {}).then((res) => {
          setCities(res?.data || []);
        });
      }, []);

    return (
        <List
            actions={<ListActions/>}
            sx={{
              "& .RaList-content": {
                boxShadow: "none",
                backgroundColor: "transparent",
              },
            }}
        >
            <>
            <CommonFilterCard fields={filterFields} />

            <br />

            <StyledDatagridWrapper title="Areas">
            <Datagrid bulkActionButtons={checkMultiSelect()} sx={commonDatagridSx}>
                {
                    isCustomSelectOpen &&
                    <ResourceSelectDialogButton />
                }
                <TextField source="id" />
                <TextField source="name" />
                <ReferenceField source="cityId" link="show" reference="Cities">
                    <TextField source="name" />
                </ReferenceField>
                <BooleanField source="isServiceable" />
                <FunctionField label="Created At" render={(record: any) => record?.createdAt ? formatDateTimeWithSeconds(record.createdAt) : '-'} />
                <FunctionField label="Updated At" render={(record: any) => record?.updatedAt ? formatDateTimeWithSeconds(record.updatedAt) : '-'} />
                <ShowButton />
            </Datagrid>
            </StyledDatagridWrapper>
            </>
        </List>
    )
}

export default AreaList;
